// Components==============
import React from 'react';
import { motion } from 'framer-motion';
import './index.module.scss';
import { useOpenUrlModal } from 'utilities/useOpenUrlModal';
// =========================

export default function AgendaCard({ title, date, id, network }) {
    const openInformationModal = useOpenUrlModal(`agenda/event-popup/${id}`);

    return (
        <>
            <motion.div
                onClick={() => {
                    if (network) {
                        window.location.href = `agenda/event-popup/${id}`;
                        return;
                    }
                    openInformationModal();
                }}
                styleName="cards"
                whileHover={{ scale: 1.025 }}
                whileTap={{ scale: 0.975 }}
            >
                <p styleName="date">{date}</p>
                <p styleName="title">{title}</p>
            </motion.div>
        </>
    );
}
